import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import InputAdornment from "@mui/material/InputAdornment";

import TextField from "@mui/material/TextField";
import TablePagination from "@mui/material/TablePagination";
import Tab from "@mui/material/Tab";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import DataUsageIcon from "@mui/icons-material/DataUsage"; // Common Data icon

import SchoolIcon from "@mui/icons-material/School"; // Thalir (schools)
import AccountBalanceIcon from "@mui/icons-material/AccountBalance"; // YUVA (institutes)
import DashboardIcon from "@mui/icons-material/Dashboard";
import NavigationIcon from "@mui/icons-material/Navigation";
import BuildIcon from "@mui/icons-material/Build";
import DomainIcon from "@mui/icons-material/Domain";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import GroupsIcon from "@mui/icons-material/Groups";
import GavelIcon from "@mui/icons-material/Gavel";
import EditNoteIcon from "@mui/icons-material/EditNote";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import MapIcon from "@mui/icons-material/Map";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import HistoryIcon from "@mui/icons-material/History";
import SearchIcon from '@mui/icons-material/Search';
import GroupWorkIcon from "@mui/icons-material/GroupWork"; // Manage Region EM
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount"; // Manage EMs
import PeopleIcon from "@mui/icons-material/People";
import DescriptionIcon from "@mui/icons-material/Description"; // MoU Dashboard
import FilterListIcon from "@mui/icons-material/FilterList";
import Chip from "@mui/material/Chip";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
// My css
import css from "../../css/admin/home-page.module.css";

import { SERVER_ORIGIN } from "../../utilities/constants";
import {
  hasReadOnlyAccess,
  hasAdminAccess,
} from "../../utilities/helper_functions";
import Loader from "../../components/common/Loader";

const HomePage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("common");
  const [regionCount, setRegionCount] = useState(null);
  const [chapterCount, setChapterCount] = useState(null);
  const [thalirstudentCount, setthalirStudentCount] = useState(null);
  const [yuvastudentCount, setYuvaStudentCount] = useState(null);
  const [instituteCount, setInstituteCount] = useState(null);
  const [emCount, setEmCount] = useState(null);
  const [regionEmCount, setregionEmCount] = useState(null);
  const [isYuvaECCount, setyuvaecCount] = useState(null);
  const [ithalirCCount, setthalirCount] = useState(null);
  const [termsCount, settermsCount] = useState(null);

  const [chapterGrowth, setChapterGrowth] = useState("0.0");
  const [regionGrowth, setRegionGrowth] = useState("0.0");
  const [emGrowth, setEmGrowth] = useState("0.0");
  const [regionEmGrowth, setRegionEmGrowth] = useState("0.0");
  const [instituteGrowth, setInstituteGrowth] = useState("0.0");
  const [yuvaECGrowth, setYuvaECGrowth] = useState("0.0");
  const [thalirGrowth, setThalirGrowth] = useState("0.0");
  const [termsGrowth, setTermsGrowth] = useState("0.0");
  const [thalirStudentGrowth, setThalirStudentGrowth] = useState("0.0");
  const [yuvaStudentGrowth, setYuvaStudentGrowth] = useState("0.0");
  const [termsthalirCount, settermsthalirCount] = useState(null);
  const [termsyuvaCount, settermsyuvaCount] = useState(null);
  const [thalirTermsGrowth, setThalirTermsGrowth] = useState("0.0");
  const [yuvatermsGrowth, setYuvatermsGrowth] = useState("0.0");
  const [resultData, setResultData] = useState([]);

  // RegionEM Chapter Summary states
  const [chapterSummary, setChapterSummary] = useState([]);
  const [chapterSummaryLoading, setChapterSummaryLoading] = useState(false);

  // Chapter details dialog (institutes/schools with student counts)
  const [chapterDetailsOpen, setChapterDetailsOpen] = useState(false);
  const [chapterDetailsLoading, setChapterDetailsLoading] = useState(false);
  const [selectedChapterName, setSelectedChapterName] = useState("");
  const [chapterDetails, setChapterDetails] = useState([]);

  // RegionEM YUVA onboarding completion (students)
  const [yuvaOnboardingCompletion, setYuvaOnboardingCompletion] = useState(0);

  const [thalirUploadedSheets, setThalirUploadedSheets] = useState([]);
  const [mouLoading, setMouLoading] = useState(false);
  const [mouFilters, setMouFilters] = useState({
    module: "",
    chapter: "",
    instituteId: "",
  });
  const [mouActiveTab, setMouActiveTab] = useState("active"); // active, expiring, expired

  const navigate = useNavigate();
  // ──── NEW STATES for search + pagination ──────
  const [mouSearchTerm, setMouSearchTerm] = useState("");
  const [mouPage, setMouPage] = useState(0);
  const [mouRowsPerPage, setMouRowsPerPage] = useState(10);
  const [mouDashboardData, setMouDashboardData] = useState({
    active: { count: 0, items: [] },
    expiring: { count: 0, items: [] },
    expired: { count: 0, items: [] },
    total: 0,
  });

  const isReadOnly = hasReadOnlyAccess();
  const hasAdmin = hasAdminAccess();
  console.log("hasAdmin in ServicesPage:", hasAdmin);
  const userType = sessionStorage.getItem("userType");
  const regionEMfor = sessionStorage.getItem("regionEMfor"); // 👈 added
  console.log("regionEMfor in ServicesPage:", regionEMfor);
  // Add state to track which card is being hovered
  const [hoveredCard, setHoveredCard] = useState(null);
  // Reset page to 0 when important filters / tab / search change
  useEffect(() => {
    setMouPage(0);
  }, [mouFilters, mouActiveTab, mouSearchTerm, mouDashboardData]);

  // ──── Your existing fetch effect remains unchanged ────
  useEffect(() => {
    if (activeTab === "mou-dashboard" && hasAdmin) {
      fetchMouDashboardData();
    }
  }, [activeTab, mouFilters, hasAdmin]);
  console.log("thalirUploadedSheets in ServicesPage:", thalirUploadedSheets);
  // MoU Dashboard states



  const currentItems = mouDashboardData[mouActiveTab]?.items || [];

  const filteredItems = useMemo(() => {
    if (!mouSearchTerm?.trim()) return currentItems;

    const search = mouSearchTerm.toLowerCase().trim();

    return currentItems.filter((mou) =>
      (mou.name || "").toLowerCase().includes(search) ||
      (mou.chapterName || "").toLowerCase().includes(search) ||
      (mou.isThalir ? "THALIR" : "YUVA").toLowerCase().includes(search)
    );
  }, [currentItems, mouSearchTerm]);

  const totalFiltered = filteredItems.length;

  const paginatedItems = useMemo(() => {
    const start = mouPage * mouRowsPerPage;
    return filteredItems.slice(start, start + mouRowsPerPage);
  }, [filteredItems, mouPage, mouRowsPerPage]);


  const getCardStyle = (cardType, index) => {
    // Different gradient patterns for variety
    const gradients = [
      "linear-gradient(270deg, #f0f8ff, #e6f7ff, #f0f8ff)", // Light blue
      "linear-gradient(270deg, #fff0f5, #ffe6ee, #fff0f5)", // Light pink
      "linear-gradient(270deg, #f0fff0, #e6ffe6, #f0fff0)", // Light green
      "linear-gradient(270deg, #fffaf0, #fff5e6, #fffaf0)", // Light orange
    ];
    const hoverGradients = [
      "linear-gradient(270deg, #e1f5fe, #b3e5fc, #e1f5fe)", // Brighter blue
      "linear-gradient(270deg, #fce4ec, #f8bbd0, #fce4ec)", // Brighter pink
      "linear-gradient(270deg, #e8f5e9, #c8e6c9, #e8f5e9)", // Brighter green
      "linear-gradient(270deg, #fff3e0, #ffe0b2, #fff3e0)", // Brighter orange
    ];

    const gradient = gradients[index % gradients.length];
    const hoverGradient = hoverGradients[index % hoverGradients.length];
    const isHovered = hoveredCard === cardType;

    return {
      marginBottom: "20px",
      padding: "10px",
      background: isHovered ? hoverGradient : gradient,
      backgroundSize: "200% 200%",
      animation: isHovered
        ? "hoverLightMoment 1.5s ease infinite"
        : "continuousLightMoment 4s ease infinite",
      transition: "all 0.3s ease",
      boxShadow: isHovered
        ? "0 8px 20px rgba(0,0,0,0.15)"
        : "0 4px 12px rgba(0,0,0,0.08)",
      cursor: "pointer",
      transform: isHovered ? "translateY(-3px)" : "translateY(0)",
    };
  };

  useEffect(() => {
    async function canVisitPage() {
      setIsLoading(true);

      try {
        const currentUserType = sessionStorage.getItem("userType");
        let verifyEndpoint = "";
        let headers = {
          "Content-Type": "application/json",
          "auth-token": sessionStorage.getItem("token"),
        };

        // Choose the correct verification endpoint based on user type
        if (currentUserType === "admin") {
          verifyEndpoint = `${SERVER_ORIGIN}/api/admin/auth/verify-token`;
          const adminId = process.env.REACT_APP_ADMIN_ID;
          const adminPassword = process.env.REACT_APP_ADMIN_PASSWORD;
          const basicAuth = btoa(`${adminId}:${adminPassword}`);
          headers.Authorization = `Basic ${basicAuth}`;
        } else if (currentUserType === "regionem") {
          verifyEndpoint = `${SERVER_ORIGIN}/api/regionem/auth/verify-token`;
        } else {
          // Invalid user type for this page
          navigate("/login");
          return;
        }

        const response = await fetch(verifyEndpoint, {
          method: "POST",
          headers: headers,
        });

        const result = await response.json();

        if (response.status >= 400 && response.status < 600) {
          if (response.status === 401) {
            navigate(`/login?userType=${currentUserType}`);
          }
        } else if (response.ok && response.status === 200) {
          // Token verified, continue to load page
        } else {
          navigate(`/login?userType=${currentUserType}`);
        }
      } catch (err) {
        console.log(err.message);
        navigate("/login");
      }
      setIsLoading(false);
    }

    async function counting() {
      setIsLoading(true);

      try {
        const currentUserType = sessionStorage.getItem("userType");
        let countingEndpoint = "";
        let headers = {
          "Content-Type": "application/json",
          "auth-token": sessionStorage.getItem("token"),
        };
        console.log("userType in counting():", currentUserType);
        console.log("session token in counting():", sessionStorage.getItem("token"));
        // Choose the correct counting endpoint based on user type
        if (currentUserType === "admin") {
          countingEndpoint = `${SERVER_ORIGIN}/api/admin/auth/count/all`;
          const adminId = process.env.REACT_APP_ADMIN_ID;
          const adminPassword = process.env.REACT_APP_ADMIN_PASSWORD;
          const basicAuth = btoa(`${adminId}:${adminPassword}`);
          headers.Authorization = `Basic ${basicAuth}`;
        } else if (currentUserType === "regionem") {
          const region = sessionStorage.getItem("region");

          countingEndpoint = `${SERVER_ORIGIN}/api/admin/auth/count/all?region=${region}&&role=regionem`;

          // countingEndpoint = `${SERVER_ORIGIN}/api/admin/auth/count/all?region=${sessionStorage.getItem("region")}`;
        } else {
          return;
        }

        const response = await fetch(`${countingEndpoint}`, {
          method: currentUserType === "admin" ? "GET" : "GET",
          headers: {
            ...headers,
            "Cache-Control": "no-cache, no-store, must-revalidate",
            "Pragma": "no-cache",
          },
        });

        const result = await response.json();
        console.log(result);

        if (response.status >= 400 && response.status < 600) {
          if (response.status === 401) {
            navigate(`/login?userType=${currentUserType}`);
          }
        } else if (response.ok && response.status === 200) {
          setRegionCount(result.data.regionCount || 0);
          setChapterCount(result.data.chapterCount || 0);
          //   setStudentCount(result.data.studentCount || 0);
          setInstituteCount(result.data.instituteCount || 0);
          setregionEmCount(result.data.regionEmCount || 0);
          setEmCount(result.data.emCount || 0);
          setyuvaecCount(result.data.yuvaECCount || 0);
          setthalirCount(result.data.thalirCount || 0);
          settermsCount(result.data.termsCount || 0);
          setthalirStudentCount(result.data.thalirStudentCount || 0);
          setYuvaStudentCount(result.data.yuvaStudentCount || 0);
          settermsyuvaCount(result.data.yuvaTermsAcceptedCount || 0);
          settermsthalirCount(result.data.thalirTermsAcceptedCount || 0);

          // 👇 Add growth states
          setRegionGrowth(result.data.regionGrowth || "0.0");
          setChapterGrowth(result.data.chapterGrowth || "0.0");
          setInstituteGrowth(result.data.instituteGrowth || "0.0");
          setRegionEmGrowth(result.data.regionEmGrowth || "0.0");
          setEmGrowth(result.data.emGrowth || "0.0");
          setYuvaECGrowth(result.data.yuvaECGrowth || "0.0");
          setThalirGrowth(result.data.thalirGrowth || "0.0");
          setTermsGrowth(result.data.termsGrowth || "0.0");
          setThalirStudentGrowth(result.data.thalirStudentGrowth || "0.0");
          setYuvaStudentGrowth(result.data.yuvaStudentGrowth || "0.0");
          setYuvatermsGrowth(result.data.yuvaTermsAcceptedGrowth || "0.0");
          setThalirTermsGrowth(result.data.thalirTermsAcceptedGrowth || "0.0");
          setResultData(result.data.result || []);

          // RegionEM specific: calculate YUVA onboarding completion %
          if (currentUserType === "regionem") {
            const invited = result.data.yuvaOnboardingInvited || 0;
            const onboarded = result.data.yuvaOnboardingOnboarded || 0;
            const completion =
              invited > 0 ? Math.round((onboarded / invited) * 100) : 0;
            setYuvaOnboardingCompletion(completion);
          }
        } else {
          // for future
        }
      } catch (err) {
        console.log(err.message);
      }
      setIsLoading(false);
    }

    canVisitPage();
    counting();

    // Fetch chapter summary for regionEM
    if (userType === "regionem") {
      fetchChapterSummary();
    }
  }, [navigate, userType]);

  const fetchChapterSummary = async () => {
    setChapterSummaryLoading(true);
    try {
      const region = sessionStorage.getItem("region");
      const response = await fetch(
        `${SERVER_ORIGIN}/api/regionem/auth/chapter-summary?region=${region}&_t=${Date.now()}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": sessionStorage.getItem("token"),
            "Cache-Control": "no-cache, no-store, must-revalidate",
            "Pragma": "no-cache",
          },
        }
      );

      const result = await response.json();
      console.log("setChapterSummary:", result);
      if (response.ok && response.status === 200) {
        setChapterSummary(result.data || []);
      } else {
        console.error("Failed to fetch chapter summary:", result);
      }
    } catch (err) {
      console.error("Error fetching chapter summary:", err.message);
    }
    setChapterSummaryLoading(false);
  };

  const handleChapterCardClick = async (chapterName) => {
    if (!chapterName) return;
    setSelectedChapterName(chapterName);
    setChapterDetailsOpen(true);
    setChapterDetailsLoading(true);
    try {
      const region = sessionStorage.getItem("region");
      const params = new URLSearchParams();
      params.append("chapterName", chapterName);
      if (region) params.append("region", region);

      const response = await fetch(
        `${SERVER_ORIGIN}/api/regionem/auth/chapter-summary/details?${params.toString()}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": sessionStorage.getItem("token"),
            "Cache-Control": "no-cache, no-store, must-revalidate",
            Pragma: "no-cache",
          },
        }
      );

      const result = await response.json();
      if (response.ok) {
        setChapterDetails(result.data || []);
      } else {
        console.error("Failed to fetch chapter details:", result);
      }
    } catch (err) {
      console.error("Error fetching chapter details:", err.message);
    }
    setChapterDetailsLoading(false);
  };

  // Fetch Thalir Uploaded Sheets (Admin only)
  useEffect(() => {
    if (activeTab === "thalir" && hasAdmin) {
      fetchThalirUploadedSheets();
    }
  }, [activeTab, hasAdmin]);

  const fetchThalirUploadedSheets = async () => {
    try {
      const adminId = process.env.REACT_APP_ADMIN_ID || "yuva@gmail.com";
      const adminPassword = process.env.REACT_APP_ADMIN_PASSWORD || "admin@yuva123";
      const basicAuth = btoa(`${adminId}:${adminPassword}`);
      const response = await fetch(`${SERVER_ORIGIN}/api/admin/auth/thalir-uploaded-sheets`, {
        headers: {
          "auth-token": sessionStorage.getItem("token"),
          Authorization: `Basic ${basicAuth}`,
        },
      });
      const result = await response.json();
      if (response.ok && result.data) {
        setThalirUploadedSheets(result.data || []);
      }
    } catch (err) {
      console.error("Fetch thalir uploaded sheets:", err);
    }
  };

  // Fetch MoU Dashboard Data
  useEffect(() => {
    if (activeTab === "mou-dashboard" && hasAdmin) {
      fetchMouDashboardData();
    }
  }, [activeTab, mouFilters, hasAdmin]);

  const fetchMouDashboardData = async () => {
    setMouLoading(true);
    try {
      const currentUserType = sessionStorage.getItem("userType");
      let headers = {
        "Content-Type": "application/json",
        "auth-token": sessionStorage.getItem("token"),
      };

      if (currentUserType === "admin") {
        const adminId = process.env.REACT_APP_ADMIN_ID;
        const adminPassword = process.env.REACT_APP_ADMIN_PASSWORD;
        const basicAuth = btoa(`${adminId}:${adminPassword}`);
        headers.Authorization = `Basic ${basicAuth}`;
      }

      const queryParams = new URLSearchParams();
      if (mouFilters.module) queryParams.append("module", mouFilters.module);
      if (mouFilters.chapter) queryParams.append("chapter", mouFilters.chapter);
      if (mouFilters.instituteId) queryParams.append("instituteId", mouFilters.instituteId);

      const response = await fetch(
        `${SERVER_ORIGIN}/api/admin/auth/mou-dashboard?${queryParams.toString()}&_t=${Date.now()}`,
        {
          method: "GET",
          headers: headers,
        }
      );

      const result = await response.json();

      if (response.ok && response.status === 200) {
        setMouDashboardData(result.data || {
          active: { count: 0, items: [] },
          expiring: { count: 0, items: [] },
          expired: { count: 0, items: [] },
          total: 0,
        });
      } else {
        console.error("Failed to fetch MoU dashboard data:", result);
      }
    } catch (err) {
      console.error("Error fetching MoU dashboard:", err.message);
    }
    setMouLoading(false);
  };

  function handleContentClick() {
    navigate("/admin/verticals/all");
  }

  function handleUsersClick() {
    navigate("/admin/users/all");
  }
  function handleInstitutesClick() {
    navigate("/institutes/all");
  }
  function handleEMClick() {
    navigate("/em/all");
  }
  function handleChapterClick() {
    navigate("/chapter/all");
  }
  function handleRegionClick() {
    navigate("/region/all");
  }

  function handleStateClick() {
    navigate("/state/all");
  }
  function handleCityClick() {
    navigate("/city/all");
  }
  function handleRegionEMClick() {
    navigate("/region-em/all");
  }

  function handleTermsAndConditionsClick() {
    navigate("/terms-conditions/all");
  }

  function handleMassEmailClick() {
    navigate("/admin/mass-email");
  }

  function handleEmailHistoryClick() {
    navigate("/admin/email-history");
  }

  function handleYuvaEcRolesClick() {
    navigate("/admin/yuva-ec-roles");
  }

  function handleAuditHistoryClick() {
    navigate("/admin/audit-history");
  }

  function handleConfigurationClick() {
    navigate("/admin/configuration");
  }

  function handleHistoricalMoUClick() {
    navigate("/admin/historical-mou");
  }

  // Helper function to get background color based on index
  const getBackgroundColor = (index) => {
    const colors = [
      "#e6f3ff",
      "#ffe6e6",
      "#e6ffe6",
      "#fff3e6",
      "#e6e6ff",
      "#ffebcc",
    ];
    return colors[index % colors.length];
  };

  function handleManageReportsClick() {
    // This will be expanded when we have multiple reports
    navigate("/admin/reports/single-mou");
  }

  const renderGrowth = (growth) => (
    <Typography
      variant="body2"
      color={parseFloat(growth) >= 0 ? "success.main" : "error.main"}
    >
      {parseFloat(growth) >= 0 ? "↑" : "↓"} {growth}% vs last month
    </Typography>
  );

  // Function to get font styles based on hover state
  const getFontStyle = (cardType, type = "title") => {
    const isHovered = hoveredCard === cardType;

    switch (type) {
      case "title":
        return {
          fontWeight: isHovered ? 700 : 600,
          fontSize: isHovered ? "1.1rem" : "1rem",
          color: isHovered ? "#1a56db" : "#2c3e50",
          transition: "all 0.3s ease",
        };
      case "count":
        return {
          fontWeight: isHovered ? 800 : 700,
          fontSize: isHovered ? "2.5rem" : "2.25rem",
          color: isHovered ? "#1e40af" : "#2f80ed",
          transition: "all 0.3s ease",
        };
      case "description":
        return {
          fontWeight: isHovered ? 500 : 400,
          color: isHovered ? "#4b5563" : "#7f8c8d",
          transition: "all 0.3s ease",
        };
      default:
        return {};
    }
  };

  const renderRegionEMChapterSummary = () => (
    <div>
      <h5
        style={{
          fontWeight: 600,
          marginTop: 10,
          marginBottom: 15,
          color: "#2f80ed",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <MenuBookIcon style={{ fontSize: 20 }} />
        Chapter-wise Summary
      </h5>
      {chapterSummaryLoading ? (
        <div style={{ textAlign: "center", padding: "40px" }}>
          <Loader />
        </div>
      ) : chapterSummary.length === 0 ? (
        <Card style={{ padding: "20px", textAlign: "center" }}>
          <Typography variant="body1" color="text.secondary">
            No chapters found in your region
          </Typography>
        </Card>
      ) : (
        <Row>
          {chapterSummary.map((chapter, index) => (
            <Col md={4} sm={6} xs={12} key={index} className="mb-4">
              <Card
                className={css.serviceCountCard}
                style={getCardStyle(`chapter-${index}`, index)}
                onMouseEnter={() => setHoveredCard(`chapter-${index}`)}
                onMouseLeave={() => setHoveredCard(null)}
                onClick={() =>
                  handleChapterCardClick(chapter.chapterName || "")
                }
              >
                <CardContent>
                  <Typography
                    variant="h6"
                    style={getFontStyle(`chapter-${index}`, "title")}
                  >
                    {chapter.chapterName}
                  </Typography>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      marginTop: "15px",
                    }}
                  >
                    <div style={{ textAlign: "center" }}>
                      <Typography
                        variant="h4"
                        style={getFontStyle(`chapter-${index}`, "count")}
                      >
                        {chapter.yuvaInstitutes || 0}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        YUVA Colleges
                      </Typography>
                    </div>
                    <div style={{ textAlign: "center" }}>
                      <Typography
                        variant="h4"
                        style={getFontStyle(`chapter-${index}`, "count")}
                      >
                        {chapter.thalirSchools || 0}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Thalir Schools
                      </Typography>
                    </div>
                  </div>
                  <div style={{ marginTop: "15px", textAlign: "center" }}>
                    <Typography variant="body1" fontWeight={600}>
                      Total: {chapter.totalInstitutes || 0}
                    </Typography>
                  </div>
                </CardContent>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </div>
  );

  const renderCommonOverview = () => (
    <div>
      {/* RegionEM Chapter Summary */}

      {/* Common Data Overview */}
      <h5
        style={{
          fontWeight: 600,
          marginTop: 10,
          marginBottom: 15,
          color: "#2f80ed",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <DashboardIcon style={{ fontSize: 20 }} />
        Central Data Overview
      </h5>
      <Row>
        <Col md={3} sm={6} xs={12}>
          <Card
            className={css.serviceCountCard}
            style={getCardStyle("chapters", 0)}
            onMouseEnter={() => setHoveredCard("chapters")}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <MenuBookIcon
                  fontSize="small"
                  style={{ fontSize: 20, color: "#2f80ed" }}
                />
                <Typography variant="subtitle2" color="text.secondary">
                  Chapters
                </Typography>
              </div>
              <Typography
                variant="h4"
                // style={{ margin: "10px 0" }}
                style={{
                  margin: "10px 0",
                  ...getFontStyle("chapters", "count"),
                }}
              >
                {chapterCount}
              </Typography>

              {renderGrowth(chapterGrowth)}

              <Typography
                variant="body2"
                color="primary"
                style={{
                  marginTop: "5px",
                  cursor: "pointer",
                  fontWeight: hoveredCard === "chapters" ? 600 : 500,
                  color: hoveredCard === "chapters" ? "#1d4ed8" : "#2f80ed",
                  transition: "all 0.3s ease",
                }}
                onClick={handleChapterClick}
              >
                View details →
              </Typography>
            </CardContent>
          </Card>
        </Col>

        <Col md={3} sm={6} xs={12}>
          <Card
            className={css.serviceCountCard}
            style={getCardStyle("chapterEm", 1)}
            onMouseEnter={() => setHoveredCard("chapterEm")}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <AssignmentIndIcon
                  fontSize="small"
                  style={{ fontSize: 20, color: "#2f80ed" }}
                />
                <Typography
                  variant="subtitle2"
                  // color="text.secondary"
                  style={getFontStyle("chapterEm", "title")}
                >
                  Chapter EM
                </Typography>
              </div>
              <Typography
                variant="h4"
                style={{
                  margin: "10px 0",
                  ...getFontStyle("chapterEm", "count"),
                }}
              >
                {emCount}
              </Typography>

              {renderGrowth(emGrowth)}
              <Typography
                variant="body2"
                color="primary"
                style={{
                  marginTop: "5px",
                  cursor: "pointer",
                  fontWeight: hoveredCard === "chapterEm" ? 600 : 500,
                  color: hoveredCard === "chapterEm" ? "#1d4ed8" : "#2f80ed",
                  transition: "all 0.3s ease",
                }}
                onClick={handleEMClick}
              >
                View details →
              </Typography>
            </CardContent>
          </Card>
        </Col>

        <Col md={3} sm={6} xs={12}>
          <Card
            className={css.serviceCountCard}
            style={getCardStyle("regions", 2)}
            onMouseEnter={() => setHoveredCard("regions")}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <MapIcon
                  fontSize="small"
                  style={{ fontSize: 20, color: "#2f80ed" }}
                />
                <Typography
                  variant="subtitle2"
                  color="text.secondary"
                  style={getFontStyle("regions", "title")}
                >
                  Regions
                </Typography>
              </div>
              <Typography
                variant="h4"
                style={{
                  margin: "10px 0",
                  ...getFontStyle("regions", "count"),
                }}
              >
                {regionCount}
              </Typography>
              {renderGrowth(regionGrowth)}
              <Typography
                variant="body2"
                color="primary"
                style={{
                  marginTop: "5px",
                  cursor: "pointer",
                  fontWeight: hoveredCard === "regions" ? 600 : 500,
                  color: hoveredCard === "regions" ? "#1d4ed8" : "#2f80ed",
                  transition: "all 0.3s ease",
                }}
                onClick={handleRegionClick}
              >
                View details →
              </Typography>
            </CardContent>
          </Card>
        </Col>

        <Col md={3} sm={6} xs={12}>
          <Card
            className={css.serviceCountCard}
            style={getCardStyle("regionEm", 3)}
            onMouseEnter={() => setHoveredCard("regionEm")}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <LocationCityIcon
                  fontSize="small"
                  style={{ fontSize: 20, color: "#2f80ed" }}
                />
                <Typography
                  variant="subtitle2"
                  color="text.secondary"
                  style={getFontStyle("regionEm", "title")}
                >
                  Regional Mentor
                </Typography>
              </div>
              <Typography
                variant="h4"
                style={{
                  margin: "10px 0",
                  ...getFontStyle("regionEm", "count"),
                }}
              >
                {regionEmCount}
              </Typography>

              {renderGrowth(regionEmGrowth)}

              <Typography
                variant="body2"
                color="primary"
                // style={{ marginTop: "5px", cursor: "pointer" }}
                style={{
                  marginTop: "5px",
                  cursor: "pointer",
                  fontWeight: hoveredCard === "regionEm" ? 600 : 500,
                  color: hoveredCard === "regionEm" ? "#1d4ed8" : "#2f80ed",
                  transition: "all 0.3s ease",
                }}
                onClick={handleRegionEMClick}
              >
                View details →
              </Typography>
            </CardContent>
          </Card>
        </Col>
      </Row>

      {/* Quick Navigation */}
      <h5
        style={{
          fontWeight: 600,
          marginTop: 25,
          marginBottom: 15,
          color: "#2f80ed",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <NavigationIcon style={{ fontSize: 20 }} />
        Quick Navigation
      </h5>

      <Row>
        {/* Manage Chapters Card */}
        <Col md={4} sm={6} xs={12} className="mb-4">
          <Card
            style={{
              padding: "20px",
              textAlign: "left",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              height: "100%",
              border: "none",
              backgroundColor: "white",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CardContent
              style={{
                padding: "0",
                flex: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "12px",
                }}
              >
                <MenuBookIcon fontSize="small" style={{ color: "#2f80ed" }} />
                <Typography
                  variant="subtitle1"
                  fontWeight={600}
                  style={{ color: "#2c3e50" }}
                >
                  Manage Chapters
                </Typography>
              </div>
              <Typography
                variant="body2"
                style={{
                  marginBottom: "20px",
                  color: "#7f8c8d",
                  fontSize: "14px",
                  lineHeight: "1.4",
                  flex: 1,
                }}
              >
                Chapter master data management
              </Typography>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "auto",
                  gap: "8px",
                }}
              >
                <button
                  style={{
                    padding: "8px 20px",
                    borderRadius: "6px",
                    border: "1px solid #2f80ed",
                    backgroundColor: "transparent",
                    color: "#2f80ed",
                    fontWeight: "500",
                    cursor: "pointer",
                    fontSize: "14px",
                    transition: "all 0.2s ease",
                    minWidth: "70px",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#2f80ed";
                    e.target.style.color = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#2f80ed";
                  }}
                  onClick={handleChapterClick}
                >
                  Open
                </button>
                {sessionStorage.getItem("userType") !== "regionem" && (
                  <button
                    style={{
                      padding: "8px 20px",
                      borderRadius: "6px",
                      border: "1px solid #27ae60",
                      backgroundColor: "transparent",
                      color: "#27ae60",
                      fontWeight: "500",
                      cursor: "pointer",
                      fontSize: "14px",
                      transition: "all 0.2s ease",
                      minWidth: "90px",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#27ae60";
                      e.target.style.color = "white";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "transparent";
                      e.target.style.color = "#27ae60";
                    }}
                    onClick={() => navigate("/admin/chapter/insert")}
                  >
                    + Add New
                  </button>
                )}
              </div>
            </CardContent>
          </Card>
        </Col>

        {/* Manage Regions Card */}
        <Col md={4} sm={6} xs={12} className="mb-4">
          <Card
            style={{
              padding: "20px",
              textAlign: "left",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              height: "100%",
              border: "none",
              backgroundColor: "white",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CardContent
              style={{
                padding: "0",
                flex: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "12px",
                }}
              >
                <MapIcon fontSize="small" style={{ color: "#e74c3c" }} />
                <Typography
                  variant="subtitle1"
                  fontWeight={600}
                  style={{ color: "#2c3e50" }}
                >
                  Manage Regions
                </Typography>
              </div>
              <Typography
                variant="body2"
                style={{
                  marginBottom: "20px",
                  color: "#7f8c8d",
                  fontSize: "14px",
                  lineHeight: "1.4",
                  flex: 1,
                }}
              >
                Region master data management
              </Typography>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "auto",
                }}
              >
                <button
                  style={{
                    padding: "8px 20px",
                    borderRadius: "6px",
                    border: "1px solid #e74c3c",
                    backgroundColor: "transparent",
                    color: "#e74c3c",
                    fontWeight: "500",
                    cursor: "pointer",
                    fontSize: "14px",
                    transition: "all 0.2s ease",
                    minWidth: "70px",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#e74c3c";
                    e.target.style.color = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#e74c3c";
                  }}
                  onClick={handleRegionClick}
                >
                  Open
                </button>
              </div>
            </CardContent>
          </Card>
        </Col>
        {/* Manage States Card */}
        <Col md={4} sm={6} xs={12} className="mb-4">
          <Card
            style={{
              padding: "20px",
              textAlign: "left",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              height: "100%",
              border: "none",
              backgroundColor: "white",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CardContent
              style={{
                padding: "0",
                flex: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "12px",
                }}
              >
                <MapIcon fontSize="small" style={{ color: "#e74c3c" }} />
                <Typography
                  variant="subtitle1"
                  fontWeight={600}
                  style={{ color: "#2c3e50" }}
                >
                  Manage States
                </Typography>
              </div>
              <Typography
                variant="body2"
                style={{
                  marginBottom: "20px",
                  color: "#7f8c8d",
                  fontSize: "14px",
                  lineHeight: "1.4",
                  flex: 1,
                }}
              >
                State master data management
              </Typography>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "auto",
                }}
              >
                <button
                  style={{
                    padding: "8px 20px",
                    borderRadius: "6px",
                    border: "1px solid #e74c3c",
                    backgroundColor: "transparent",
                    color: "#e74c3c",
                    fontWeight: "500",
                    cursor: "pointer",
                    fontSize: "14px",
                    transition: "all 0.2s ease",
                    minWidth: "70px",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#e74c3c";
                    e.target.style.color = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#e74c3c";
                  }}
                  onClick={handleStateClick}
                >
                  Open
                </button>
              </div>
            </CardContent>
          </Card>
        </Col>

        {/* Manage States Card */}
        <Col md={4} sm={6} xs={12} className="mb-4">
          <Card
            style={{
              padding: "20px",
              textAlign: "left",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              height: "100%",
              border: "none",
              backgroundColor: "white",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CardContent
              style={{
                padding: "0",
                flex: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "12px",
                }}
              >
                <MapIcon fontSize="small" style={{ color: "#e74c3c" }} />
                <Typography
                  variant="subtitle1"
                  fontWeight={600}
                  style={{ color: "#2c3e50" }}
                >
                  Manage Cities
                </Typography>
              </div>
              <Typography
                variant="body2"
                style={{
                  marginBottom: "20px",
                  color: "#7f8c8d",
                  fontSize: "14px",
                  lineHeight: "1.4",
                  flex: 1,
                }}
              >
                City master data management
              </Typography>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "auto",
                }}
              >
                <button
                  style={{
                    padding: "8px 20px",
                    borderRadius: "6px",
                    border: "1px solid #e74c3c",
                    backgroundColor: "transparent",
                    color: "#e74c3c",
                    fontWeight: "500",
                    cursor: "pointer",
                    fontSize: "14px",
                    transition: "all 0.2s ease",
                    minWidth: "70px",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#e74c3c";
                    e.target.style.color = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#e74c3c";
                  }}
                  onClick={handleCityClick}
                >
                  Open
                </button>
              </div>
            </CardContent>
          </Card>
        </Col>

        {/* Manage Region EM Card */}
        <Col md={4} sm={6} xs={12} className="mb-4">
          <Card
            style={{
              padding: "20px",
              textAlign: "left",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              height: "100%",
              border: "none",
              backgroundColor: "white",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CardContent
              style={{
                padding: "0",
                flex: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "12px",
                }}
              >
                <GroupWorkIcon fontSize="small" style={{ color: "#9b59b6" }} />
                <Typography
                  variant="subtitle1"
                  fontWeight={600}
                  style={{ color: "#2c3e50" }}
                >
                  Manage Regional Mentor
                </Typography>
              </div>
              <Typography
                variant="body2"
                style={{
                  marginBottom: "20px",
                  color: "#7f8c8d",
                  fontSize: "14px",
                  lineHeight: "1.4",
                  flex: 1,
                }}
              >
                Assign and manage Regional Mentors
              </Typography>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "auto",
                  gap: "8px",
                }}
              >
                <button
                  style={{
                    padding: "8px 20px",
                    borderRadius: "6px",
                    border: "1px solid #9b59b6",
                    backgroundColor: "transparent",
                    color: "#9b59b6",
                    fontWeight: "500",
                    cursor: "pointer",
                    fontSize: "14px",
                    transition: "all 0.2s ease",
                    minWidth: "70px",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#9b59b6";
                    e.target.style.color = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#9b59b6";
                  }}
                  onClick={handleRegionEMClick}
                >
                  Open
                </button>
                {sessionStorage.getItem("userType") !== "regionem" && (
                  <button
                    style={{
                      padding: "8px 20px",
                      borderRadius: "6px",
                      border: "1px solid #27ae60",
                      backgroundColor: "transparent",
                      color: "#27ae60",
                      fontWeight: "500",
                      cursor: "pointer",
                      fontSize: "14px",
                      transition: "all 0.2s ease",
                      minWidth: "90px",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#27ae60";
                      e.target.style.color = "white";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "transparent";
                      e.target.style.color = "#27ae60";
                    }}
                    onClick={() => navigate("/region-em/add")}
                  >
                    + Add New
                  </button>
                )}
              </div>
            </CardContent>
          </Card>
        </Col>

        {/* Manage EMs Card */}
        <Col md={4} sm={6} xs={12} className="mb-4">
          <Card
            style={{
              padding: "20px",
              textAlign: "left",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              height: "100%",
              border: "none",
              backgroundColor: "white",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CardContent
              style={{
                padding: "0",
                flex: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginBottom: "12px",
                }}
              >
                <SupervisorAccountIcon
                  fontSize="small"
                  style={{ color: "#f39c12" }}
                />
                <Typography
                  variant="subtitle1"
                  fontWeight={600}
                  style={{ color: "#2c3e50" }}
                >
                  Manage EMs
                </Typography>
              </div>
              <Typography
                variant="body2"
                style={{
                  marginBottom: "20px",
                  color: "#7f8c8d",
                  fontSize: "14px",
                  lineHeight: "1.4",
                  flex: 1,
                }}
              >
                EM master data and assignments
              </Typography>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "auto",
                  gap: "8px",
                }}
              >
                <button
                  style={{
                    padding: "8px 20px",
                    borderRadius: "6px",
                    border: "1px solid #f39c12",
                    backgroundColor: "transparent",
                    color: "#f39c12",
                    fontWeight: "500",
                    cursor: "pointer",
                    fontSize: "14px",
                    transition: "all 0.2s ease",
                    minWidth: "70px",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#f39c12";
                    e.target.style.color = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#f39c12";
                  }}
                  onClick={handleEMClick}
                >
                  Open
                </button>
                {sessionStorage.getItem("userType") !== "regionem" && (
                  <button
                    style={{
                      padding: "8px 20px",
                      borderRadius: "6px",
                      border: "1px solid #27ae60",
                      backgroundColor: "transparent",
                      color: "#27ae60",
                      fontWeight: "500",
                      cursor: "pointer",
                      fontSize: "14px",
                      transition: "all 0.2s ease",
                      minWidth: "90px",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#27ae60";
                      e.target.style.color = "white";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "transparent";
                      e.target.style.color = "#27ae60";
                    }}
                    onClick={() => navigate("/ems/insert")}
                  >
                    + Add New
                  </button>
                )}
              </div>
            </CardContent>
          </Card>
        </Col>
      </Row>
      {userType === "regionem" && renderRegionEMChapterSummary()}

      <h5
        style={{
          fontWeight: 600,
          marginTop: 25,
          marginBottom: 15,
          color: "#2f80ed",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <BuildIcon style={{ fontSize: 20 }} />
        Shared Utilities
      </h5>
      <Row>
        {sessionStorage.getItem("userType") !== "regionem" && (
          <Col md={6} sm={12} className="mb-3">
            <Card
              className={css.serviceCountCard}
              style={{ padding: "15px", textAlign: "left" }}
            >
              <CardContent>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    marginBottom: 6,
                  }}
                >
                  <MarkEmailReadIcon
                    fontSize="small"
                    style={{ color: "#2f80ed" }}
                  />
                  <Typography variant="subtitle1" fontWeight={600}>
                    Mass Email
                  </Typography>
                </div>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  style={{ marginBottom: "12px" }}
                >
                  Targeted bulk email campaigns across modules
                </Typography>
                {/* <button
                className={`${css.serviceBtn} outlineBtn`}
                onClick={handleMassEmailClick}
              >
                Open
              </button> */}
                <button
                  style={{
                    padding: "8px 20px",
                    borderRadius: "6px",
                    border: "1px solid #f39c12",
                    backgroundColor: "transparent",
                    color: "#f39c12",
                    fontWeight: "500",
                    cursor: "pointer",
                    fontSize: "14px",
                    transition: "all 0.2s ease",
                    minWidth: "70px",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#f39c12";
                    e.target.style.color = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#f39c12";
                  }}
                  onClick={handleMassEmailClick}
                >
                  Open
                </button>
              </CardContent>
            </Card>
          </Col>
        )}

        <Col md={6} sm={12} className="mb-3">
          <Card
            className={css.serviceCountCard}
            style={{ padding: "15px", textAlign: "left" }}
          >
            <CardContent>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  marginBottom: 6,
                }}
              >
                <HistoryIcon fontSize="small" style={{ color: "#2f80ed" }} />
                <Typography variant="subtitle1" fontWeight={600}>
                  Email History
                </Typography>
              </div>
              <Typography
                variant="body2"
                color="text.secondary"
                style={{ marginBottom: "12px" }}
              >
                Delivery status, recipient counts, performance analytics
              </Typography>
              {/* <button
                className={`${css.serviceBtn} outlineBtn`}
                onClick={handleEmailHistoryClick}
              >
                Open
              </button> */}
              <button
                style={{
                  padding: "8px 20px",
                  borderRadius: "6px",
                  border: "1px solid #f39c12",
                  backgroundColor: "transparent",
                  color: "#f39c12",
                  fontWeight: "500",
                  cursor: "pointer",
                  fontSize: "14px",
                  transition: "all 0.2s ease",
                  minWidth: "70px",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f39c12";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#f39c12";
                }}
                onClick={handleEmailHistoryClick}
              >
                Open
              </button>
            </CardContent>
          </Card>
        </Col>

        {hasAdmin && (
          <>
            <Col md={6} sm={12} className="mb-3">
              <Card className={css.serviceCountCard} style={{ padding: "15px", textAlign: "left" }}>
                <CardContent>
                  <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
                    <AssignmentIndIcon fontSize="small" style={{ color: "#2f80ed" }} />
                    <Typography variant="subtitle1" fontWeight={600}>Audit & History</Typography>
                  </div>
                  <Typography variant="body2" color="text.secondary" style={{ marginBottom: "12px" }}>
                    MoU history, student uploads, role assignments for audit
                  </Typography>
                  <button
                    style={{ padding: "8px 20px", borderRadius: "6px", border: "1px solid #f39c12", backgroundColor: "transparent", color: "#f39c12", fontWeight: "500", cursor: "pointer", fontSize: "14px", transition: "all 0.2s ease", minWidth: "70px" }}
                    onMouseEnter={(e) => { e.target.style.backgroundColor = "#f39c12"; e.target.style.color = "white"; }}
                    onMouseLeave={(e) => { e.target.style.backgroundColor = "transparent"; e.target.style.color = "#f39c12"; }}
                    onClick={handleAuditHistoryClick}
                  >
                    Open
                  </button>
                </CardContent>
              </Card>
            </Col>

            <Col md={6} sm={12} className="mb-3">
              <Card className={css.serviceCountCard} style={{ padding: "15px", textAlign: "left" }}>
                <CardContent>
                  <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
                    <BuildIcon fontSize="small" style={{ color: "#2f80ed" }} />
                    <Typography variant="subtitle1" fontWeight={600}>Configuration</Typography>
                  </div>
                  <Typography variant="body2" color="text.secondary" style={{ marginBottom: "12px" }}>
                    Durations, reminders, email template settings
                  </Typography>
                  <button
                    style={{ padding: "8px 20px", borderRadius: "6px", border: "1px solid #f39c12", backgroundColor: "transparent", color: "#f39c12", fontWeight: "500", cursor: "pointer", fontSize: "14px", transition: "all 0.2s ease", minWidth: "70px" }}
                    onMouseEnter={(e) => { e.target.style.backgroundColor = "#f39c12"; e.target.style.color = "white"; }}
                    onMouseLeave={(e) => { e.target.style.backgroundColor = "transparent"; e.target.style.color = "#f39c12"; }}
                    onClick={handleConfigurationClick}
                  >
                    Open
                  </button>
                </CardContent>
              </Card>
            </Col>

            <Col md={6} sm={12} className="mb-3">
              <Card className={css.serviceCountCard} style={{ padding: "15px", textAlign: "left" }}>
                <CardContent>
                  <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
                    <DescriptionIcon fontSize="small" style={{ color: "#2f80ed" }} />
                    <Typography variant="subtitle1" fontWeight={600}>Historical MoU</Typography>
                  </div>
                  <Typography variant="body2" color="text.secondary" style={{ marginBottom: "12px" }}>
                    Past MoU docs, EM & Institute details, update signed PDF
                  </Typography>
                  <button
                    style={{ padding: "8px 20px", borderRadius: "6px", border: "1px solid #f39c12", backgroundColor: "transparent", color: "#f39c12", fontWeight: "500", cursor: "pointer", fontSize: "14px", transition: "all 0.2s ease", minWidth: "70px" }}
                    onMouseEnter={(e) => { e.target.style.backgroundColor = "#f39c12"; e.target.style.color = "white"; }}
                    onMouseLeave={(e) => { e.target.style.backgroundColor = "transparent"; e.target.style.color = "#f39c12"; }}
                    onClick={handleHistoricalMoUClick}
                  >
                    Open
                  </button>
                </CardContent>
              </Card>
            </Col>
          </>
        )}

        <Col md={6} sm={12} className="mb-3">
          <Card
            className={css.serviceCountCard}
            style={{ padding: "15px", textAlign: "left" }}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <GavelIcon
                  fontSize="small"
                  style={{ fontSize: 20, color: "#2f80ed" }}
                />
                <Typography variant="subtitle1" fontWeight={600}>
                  Manage Terms & Conditions
                </Typography>
              </div>
              <Typography
                variant="body2"
                color="text.secondary"
                style={{ marginBottom: "12px" }}
              >
                YUVA T&C templates and submissions
              </Typography>
              {/* <button
                className={`${css.serviceBtn} outlineBtn`}
                onClick={handleTermsAndConditionsClick}
              >
                Open
              </button> */}
              <button
                style={{
                  padding: "8px 20px",
                  borderRadius: "6px",
                  border: "1px solid #f39c12",
                  backgroundColor: "transparent",
                  color: "#f39c12",
                  fontWeight: "500",
                  cursor: "pointer",
                  fontSize: "14px",
                  transition: "all 0.2s ease",
                  minWidth: "70px",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f39c12";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#f39c12";
                }}
                onClick={handleTermsAndConditionsClick}
              >
                Open
              </button>
            </CardContent>
          </Card>
        </Col>

        <Col md={6} sm={12} className="mb-3">
          <Card
            className={css.serviceCountCard}
            style={{ padding: "15px", textAlign: "left" }}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <EditNoteIcon
                  fontSize="small"
                  style={{ fontSize: 20, color: "#2f80ed" }}
                />
                <Typography variant="subtitle1" fontWeight={600}>
                  Manage Content
                </Typography>
              </div>
              <Typography
                variant="body2"
                color="text.secondary"
                style={{ marginBottom: "12px" }}
              >
                Create and update static pages
              </Typography>
              {/* <button
                className={`${css.serviceBtn} outlineBtn`}
                onClick={handleContentClick}
              >
                Open
              </button> */}
              <button
                style={{
                  padding: "8px 20px",
                  borderRadius: "6px",
                  border: "1px solid #f39c12",
                  backgroundColor: "transparent",
                  color: "#f39c12",
                  fontWeight: "500",
                  cursor: "pointer",
                  fontSize: "14px",
                  transition: "all 0.2s ease",
                  minWidth: "70px",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f39c12";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#f39c12";
                }}
                onClick={handleContentClick}
              >
                Open
              </button>
            </CardContent>
          </Card>
        </Col>
      </Row>
    </div>
  );

  const renderYuvaOverview = () => (
    <div>
      <h5
        style={{
          fontWeight: 600,
          marginTop: 10,
          marginBottom: 15,
          color: "#2f80ed",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <DomainIcon style={{ fontSize: 20 }} />
        YUVA Module Overview
      </h5>

      <Row>
        <Col md={3} sm={6} xs={12}>
          <Card
            className={css.serviceCountCard}
            style={getCardStyle("institutes", 10)}
            onMouseEnter={() => setHoveredCard("institutes")}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <DomainIcon
                  fontSize="small"
                  style={{
                    fontSize: 20,
                    color: hoveredCard === "institutes" ? "#1e40af" : "#2f80ed",
                    transition: "all 0.3s ease",
                  }}
                />
                <Typography
                  variant="subtitle2"
                  style={getFontStyle("institutes", "title")}
                >
                  Colleges
                </Typography>
              </div>
              <Typography
                variant="h4"
                style={{
                  margin: "10px 0",
                  ...getFontStyle("institutes", "count"),
                }}
              >
                {instituteCount}
              </Typography>
              {renderGrowth(instituteGrowth)}
              <Typography
                variant="body2"
                color="primary"
                style={{
                  marginTop: "5px",
                  cursor: "pointer",
                  fontWeight: hoveredCard === "institutes" ? 600 : 500,
                  color: hoveredCard === "institutes" ? "#1d4ed8" : "#2f80ed",
                  transition: "all 0.3s ease",
                }}
                onClick={() => navigate("/institutes/all?tab=institute")}
              // onClick={handleInstitutesClick}
              >
                View details →
              </Typography>
            </CardContent>
          </Card>
        </Col>

        <Col md={3} sm={6} xs={12}>
          <Card
            className={css.serviceCountCard}
            style={getCardStyle("yuvaEC", 11)}
            onMouseEnter={() => setHoveredCard("yuvaEC")}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <GroupsIcon
                  fontSize="small"
                  style={{
                    fontSize: 20,
                    color: hoveredCard === "yuvaEC" ? "#1e40af" : "#2f80ed",
                    transition: "all 0.3s ease",
                  }}
                />
                <Typography
                  variant="subtitle2"
                  style={getFontStyle("yuvaEC", "title")}
                >
                  YUVA EC
                </Typography>
              </div>
              <Typography
                variant="h4"
                style={{
                  margin: "10px 0",
                  ...getFontStyle("yuvaEC", "count"),
                }}
              >
                {isYuvaECCount}
              </Typography>
              {renderGrowth(yuvaECGrowth)}
              {sessionStorage.getItem("userType") !== "regionem" && (
                <>
                  <Typography
                    variant="body2"
                    color="primary"
                    style={{
                      marginTop: "5px",
                      cursor: "pointer",
                      fontWeight: hoveredCard === "yuvaec" ? 600 : 500,
                      color: hoveredCard === "yuvaec" ? "#1d4ed8" : "#2f80ed",
                      transition: "all 0.3s ease",
                    }}
                    onClick={() =>
                      navigate("/admin/users/all?tab=institute&isEC=true")
                    }
                  >
                    View details →
                  </Typography>

                  <Typography
                    variant="body2"
                    color="primary"
                    style={{
                      marginTop: "6px",
                      cursor: "pointer",
                      fontWeight: 500,
                      color: "#2f80ed",
                    }}
                    onClick={handleYuvaEcRolesClick}
                  >
                    Manage Roles →
                  </Typography>
                </>
              )}

            </CardContent>
          </Card>
        </Col>

        <Col md={3} sm={6} xs={12}>
          <Card
            className={css.serviceCountCard}
            style={getCardStyle("students", 12)}
            onMouseEnter={() => setHoveredCard("students")}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <SchoolIcon
                  fontSize="small"
                  style={{
                    fontSize: 20,
                    color: hoveredCard === "students" ? "#1e40af" : "#2f80ed",
                    transition: "all 0.3s ease",
                  }}
                />
                <Typography
                  variant="subtitle2"
                  style={getFontStyle("students", "title")}
                >
                  Students
                </Typography>
              </div>

              <Typography
                variant="h4"
                style={{
                  margin: "10px 0",
                  ...getFontStyle("students", "count"),
                }}
              >
                {yuvastudentCount}
              </Typography>
              {renderGrowth(yuvaStudentGrowth)}
              {sessionStorage.getItem("userType") === "regionem" ? (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  style={{ marginTop: "6px" }}
                >
                  Onboarding Completion (YUVA):{" "}
                  <strong>{yuvaOnboardingCompletion}%</strong>
                </Typography>
              ) : (
                <Typography
                  variant="body2"
                  color="primary"
                  style={{
                    marginTop: "5px",
                    cursor: "pointer",
                    fontWeight: hoveredCard === "students" ? 600 : 500,
                    color: hoveredCard === "students" ? "#1d4ed8" : "#2f80ed",
                    transition: "all 0.3s ease",
                  }}
                  // onClick={handleUsersClick}
                  onClick={() => navigate("/admin/users/all?tab=institute")}
                >
                  View details →
                </Typography>
              )}

            </CardContent>
          </Card>
        </Col>

        <Col md={3} sm={6} xs={12}>
          <Card
            className={css.serviceCountCard}
            style={getCardStyle("terms", 13)}
            onMouseEnter={() => setHoveredCard("terms")}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <GavelIcon
                  fontSize="small"
                  style={{
                    fontSize: 20,
                    color: hoveredCard === "terms" ? "#1e40af" : "#2f80ed",
                    transition: "all 0.3s ease",
                  }}
                />
                <Typography
                  variant="subtitle2"
                  style={getFontStyle("terms", "title")}
                >
                  MoU Approved
                </Typography>
              </div>
              <Typography
                variant="h4"
                style={{
                  margin: "10px 0",
                  ...getFontStyle("terms", "count"),
                }}
              >
                {termsyuvaCount}
              </Typography>
              {renderGrowth(yuvatermsGrowth)}

              <Typography
                variant="body2"
                color="primary"
                style={{
                  marginTop: "5px",
                  cursor: "pointer",
                  fontWeight: hoveredCard === "terms" ? 600 : 500,
                  color: hoveredCard === "terms" ? "#1d4ed8" : "#2f80ed",
                  transition: "all 0.3s ease",
                }}
                // onClick={handleInstitutesClick}
                onClick={() => navigate("/institutes/all?termsAccepted=true")}
              >
                View details →
              </Typography>
            </CardContent>
          </Card>
        </Col>
      </Row>

      {/* Management Section */}
      <h5
        style={{
          fontWeight: 600,
          marginTop: 25,
          marginBottom: 15,
          color: "#2f80ed",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <ManageAccountsIcon style={{ fontSize: 20 }} />
        YUVA Management
      </h5>
      <Row>
        <Col md={6} sm={12} className="mb-3">
          <Card
            className={css.serviceCountCard}
            style={{ padding: "15px", textAlign: "left" }}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <DomainIcon
                  fontSize="small"
                  style={{ fontSize: 20, color: "#2f80ed" }}
                />
                <Typography variant="subtitle1" fontWeight={600}>
                  Manage Colleges
                </Typography>
              </div>
              <Typography
                variant="body2"
                color="text.secondary"
                style={{ marginBottom: "12px" }}
              >
                College master data management
              </Typography>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "auto",
                  gap: "8px",
                }}
              >
                <button
                  style={{
                    padding: "8px 20px",
                    borderRadius: "6px",
                    border: "1px solid #f39c12",
                    backgroundColor: "transparent",
                    color: "#f39c12",
                    fontWeight: "500",
                    cursor: "pointer",
                    fontSize: "14px",
                    transition: "all 0.2s ease",
                    minWidth: "70px",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#f39c12";
                    e.target.style.color = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#f39c12";
                  }}
                  onClick={handleInstitutesClick}
                >
                  Open
                </button>
                {sessionStorage.getItem("userType") !== "regionem" && (
                  <button
                    style={{
                      padding: "8px 20px",
                      borderRadius: "6px",
                      border: "1px solid #27ae60",
                      backgroundColor: "transparent",
                      color: "#27ae60",
                      fontWeight: "500",
                      cursor: "pointer",
                      fontSize: "14px",
                      transition: "all 0.2s ease",
                      minWidth: "90px",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#27ae60";
                      e.target.style.color = "white";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "transparent";
                      e.target.style.color = "#27ae60";
                    }}
                    onClick={() => navigate("/institutes/insert?tab=institute")}
                  >
                    + Add New
                  </button>
                )}
              </div>
            </CardContent>
          </Card>
        </Col>

        <Col md={6} sm={12} className="mb-3">
          <Card
            className={css.serviceCountCard}
            style={{ padding: "15px", textAlign: "left" }}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <SchoolIcon
                  fontSize="small"
                  style={{ fontSize: 20, color: "#2f80ed" }}
                />
                <Typography variant="subtitle1" fontWeight={600}>
                  Manage Students
                </Typography>
              </div>
              <Typography
                variant="body2"
                color="text.secondary"
                style={{ marginBottom: "12px" }}
              >
                YUVA student management and filtering
              </Typography>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "auto",
                  gap: "8px",
                }}
              >
                <button
                  style={{
                    padding: "8px 20px",
                    borderRadius: "6px",
                    border: "1px solid #f39c12",
                    backgroundColor: "transparent",
                    color: "#f39c12",
                    fontWeight: "500",
                    cursor: "pointer",
                    fontSize: "14px",
                    transition: "all 0.2s ease",
                    minWidth: "70px",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#f39c12";
                    e.target.style.color = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#f39c12";
                  }}
                  // onClick={handleUsersClick}
                  onClick={() => navigate("/admin/users/all?tab=institute")}
                >
                  Open
                </button>
                {sessionStorage.getItem("userType") !== "regionem" && (
                  <button
                    style={{
                      padding: "8px 20px",
                      borderRadius: "6px",
                      border: "1px solid #27ae60",
                      backgroundColor: "transparent",
                      color: "#27ae60",
                      fontWeight: "500",
                      cursor: "pointer",
                      fontSize: "14px",
                      transition: "all 0.2s ease",
                      minWidth: "90px",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#27ae60";
                      e.target.style.color = "white";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "transparent";
                      e.target.style.color = "#27ae60";
                    }}
                    onClick={() =>
                      navigate("/user/register/no_id?tab=institute")
                    }
                  >
                    + Add New
                  </button>
                )}
              </div>
            </CardContent>
          </Card>
        </Col>
      </Row>

      <h5
        style={{
          fontWeight: 600,
          marginTop: 25,
          marginBottom: 15,
          color: "#2f80ed",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <BuildIcon style={{ fontSize: 20 }} />
        Shared Utilities
      </h5>
      <Row>
        {sessionStorage.getItem("userType") !== "regionem" && (
          <Col md={6} sm={12} className="mb-3">
            <Card
              className={css.serviceCountCard}
              style={{ padding: "15px", textAlign: "left" }}
            >
              <CardContent>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    marginBottom: 6,
                  }}
                >
                  <MarkEmailReadIcon
                    fontSize="small"
                    style={{ color: "#2f80ed" }}
                  />
                  <Typography variant="subtitle1" fontWeight={600}>
                    Mass Email
                  </Typography>
                </div>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  style={{ marginBottom: "12px" }}
                >
                  Targeted bulk email campaigns across modules
                </Typography>
                {/* <button
                className={`${css.serviceBtn} outlineBtn`}
                onClick={handleMassEmailClick}
              >
                Open
              </button> */}
                <button
                  style={{
                    padding: "8px 20px",
                    borderRadius: "6px",
                    border: "1px solid #f39c12",
                    backgroundColor: "transparent",
                    color: "#f39c12",
                    fontWeight: "500",
                    cursor: "pointer",
                    fontSize: "14px",
                    transition: "all 0.2s ease",
                    minWidth: "70px",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#f39c12";
                    e.target.style.color = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#f39c12";
                  }}
                  onClick={handleMassEmailClick}
                >
                  Open
                </button>
              </CardContent>
            </Card>
          </Col>
        )}

        <Col md={6} sm={12} className="mb-3">
          <Card
            className={css.serviceCountCard}
            style={{ padding: "15px", textAlign: "left" }}
          >
            <CardContent>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  marginBottom: 6,
                }}
              >
                <HistoryIcon fontSize="small" style={{ color: "#2f80ed" }} />
                <Typography variant="subtitle1" fontWeight={600}>
                  Email History
                </Typography>
              </div>
              <Typography
                variant="body2"
                color="text.secondary"
                style={{ marginBottom: "12px" }}
              >
                Delivery status, recipient counts, performance analytics
              </Typography>
              {/* <button
                className={`${css.serviceBtn} outlineBtn`}
                onClick={handleEmailHistoryClick}
              >
                Open
              </button> */}
              <button
                style={{
                  padding: "8px 20px",
                  borderRadius: "6px",
                  border: "1px solid #f39c12",
                  backgroundColor: "transparent",
                  color: "#f39c12",
                  fontWeight: "500",
                  cursor: "pointer",
                  fontSize: "14px",
                  transition: "all 0.2s ease",
                  minWidth: "70px",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f39c12";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#f39c12";
                }}
                onClick={handleEmailHistoryClick}
              >
                Open
              </button>
            </CardContent>
          </Card>
        </Col>

        {/* {hasAdmin && (
          <>
            <Col md={6} sm={12} className="mb-3">
              <Card className={css.serviceCountCard} style={{ padding: "15px", textAlign: "left" }}>
                <CardContent>
                  <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
                    <AssignmentIndIcon fontSize="small" style={{ color: "#2f80ed" }} />
                    <Typography variant="subtitle1" fontWeight={600}>Audit & History</Typography>
                  </div>
                  <Typography variant="body2" color="text.secondary" style={{ marginBottom: "12px" }}>
                    MoU history, student uploads, role assignments for audit
                  </Typography>
                  <button
                    style={{ padding: "8px 20px", borderRadius: "6px", border: "1px solid #f39c12", backgroundColor: "transparent", color: "#f39c12", fontWeight: "500", cursor: "pointer", fontSize: "14px", transition: "all 0.2s ease", minWidth: "70px" }}
                    onMouseEnter={(e) => { e.target.style.backgroundColor = "#f39c12"; e.target.style.color = "white"; }}
                    onMouseLeave={(e) => { e.target.style.backgroundColor = "transparent"; e.target.style.color = "#f39c12"; }}
                    onClick={handleAuditHistoryClick}
                  >
                    Open
                  </button>
                </CardContent>
              </Card>
            </Col>

            <Col md={6} sm={12} className="mb-3">
              <Card className={css.serviceCountCard} style={{ padding: "15px", textAlign: "left" }}>
                <CardContent>
                  <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
                    <BuildIcon fontSize="small" style={{ color: "#2f80ed" }} />
                    <Typography variant="subtitle1" fontWeight={600}>Configuration</Typography>
                  </div>
                  <Typography variant="body2" color="text.secondary" style={{ marginBottom: "12px" }}>
                    Durations, reminders, email template settings
                  </Typography>
                  <button
                    style={{ padding: "8px 20px", borderRadius: "6px", border: "1px solid #f39c12", backgroundColor: "transparent", color: "#f39c12", fontWeight: "500", cursor: "pointer", fontSize: "14px", transition: "all 0.2s ease", minWidth: "70px" }}
                    onMouseEnter={(e) => { e.target.style.backgroundColor = "#f39c12"; e.target.style.color = "white"; }}
                    onMouseLeave={(e) => { e.target.style.backgroundColor = "transparent"; e.target.style.color = "#f39c12"; }}
                    onClick={handleConfigurationClick}
                  >
                    Open
                  </button>
                </CardContent>
              </Card>
            </Col>

            <Col md={6} sm={12} className="mb-3">
              <Card className={css.serviceCountCard} style={{ padding: "15px", textAlign: "left" }}>
                <CardContent>
                  <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
                    <DescriptionIcon fontSize="small" style={{ color: "#2f80ed" }} />
                    <Typography variant="subtitle1" fontWeight={600}>Historical MoU</Typography>
                  </div>
                  <Typography variant="body2" color="text.secondary" style={{ marginBottom: "12px" }}>
                    Past MoU docs, EM & Institute details, update signed PDF
                  </Typography>
                  <button
                    style={{ padding: "8px 20px", borderRadius: "6px", border: "1px solid #f39c12", backgroundColor: "transparent", color: "#f39c12", fontWeight: "500", cursor: "pointer", fontSize: "14px", transition: "all 0.2s ease", minWidth: "70px" }}
                    onMouseEnter={(e) => { e.target.style.backgroundColor = "#f39c12"; e.target.style.color = "white"; }}
                    onMouseLeave={(e) => { e.target.style.backgroundColor = "transparent"; e.target.style.color = "#f39c12"; }}
                    onClick={handleHistoricalMoUClick}
                  >
                    Open
                  </button>
                </CardContent>
              </Card>
            </Col>
          </>
        )} */}

        <Col md={6} sm={12} className="mb-3">
          <Card
            className={css.serviceCountCard}
            style={{ padding: "15px", textAlign: "left" }}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <GavelIcon
                  fontSize="small"
                  style={{ fontSize: 20, color: "#2f80ed" }}
                />
                <Typography variant="subtitle1" fontWeight={600}>
                  Manage Terms & Conditions
                </Typography>
              </div>
              <Typography
                variant="body2"
                color="text.secondary"
                style={{ marginBottom: "12px" }}
              >
                YUVA T&C templates and submissions
              </Typography>
              {/* <button
                className={`${css.serviceBtn} outlineBtn`}
                onClick={handleTermsAndConditionsClick}
              >
                Open
              </button> */}
              <button
                style={{
                  padding: "8px 20px",
                  borderRadius: "6px",
                  border: "1px solid #f39c12",
                  backgroundColor: "transparent",
                  color: "#f39c12",
                  fontWeight: "500",
                  cursor: "pointer",
                  fontSize: "14px",
                  transition: "all 0.2s ease",
                  minWidth: "70px",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f39c12";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#f39c12";
                }}
                onClick={handleTermsAndConditionsClick}
              >
                Open
              </button>
            </CardContent>
          </Card>
        </Col>

        <Col md={6} sm={12} className="mb-3">
          <Card
            className={css.serviceCountCard}
            style={{ padding: "15px", textAlign: "left" }}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <EditNoteIcon
                  fontSize="small"
                  style={{ fontSize: 20, color: "#2f80ed" }}
                />
                <Typography variant="subtitle1" fontWeight={600}>
                  Manage Content
                </Typography>
              </div>
              <Typography
                variant="body2"
                color="text.secondary"
                style={{ marginBottom: "12px" }}
              >
                Create and update static pages
              </Typography>
              {/* <button
                className={`${css.serviceBtn} outlineBtn`}
                onClick={handleContentClick}
              >
                Open
              </button> */}
              <button
                style={{
                  padding: "8px 20px",
                  borderRadius: "6px",
                  border: "1px solid #f39c12",
                  backgroundColor: "transparent",
                  color: "#f39c12",
                  fontWeight: "500",
                  cursor: "pointer",
                  fontSize: "14px",
                  transition: "all 0.2s ease",
                  minWidth: "70px",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f39c12";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#f39c12";
                }}
                onClick={handleContentClick}
              >
                Open
              </button>
            </CardContent>
          </Card>
        </Col>
      </Row>
    </div>
  );
  const renderThalirOverview = () => (
    <div>
      {/* Top Stats */}
      <h5
        style={{
          fontWeight: 600,
          marginTop: 10,
          marginBottom: 15,
          color: "#2f80ed",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <SchoolIcon style={{ fontSize: 20 }} />
        Thalir Module Overview
      </h5>
      <Row>
        <Col md={4} sm={6} xs={12}>
          <Card
            className={css.serviceCountCard}
            style={getCardStyle("schools", 14)}
            onMouseEnter={() => setHoveredCard("schools")}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <SchoolIcon
                  style={{
                    color: hoveredCard === "schools" ? "#1e40af" : "#2f80ed",
                    transition: "all 0.3s ease",
                  }}
                />
                <Typography
                  variant="subtitle2"
                  style={getFontStyle("schools", "title")}
                >
                  Schools
                </Typography>
              </div>
              <Typography
                variant="h4"
                style={{
                  margin: "10px 0",
                  ...getFontStyle("schools", "count"),
                }}
              >
                {ithalirCCount}
              </Typography>
              {renderGrowth(thalirGrowth)}
              <Typography
                variant="body2"
                color="primary"
                style={{
                  marginTop: "5px",
                  cursor: "pointer",
                  fontWeight: hoveredCard === "institutes" ? 600 : 500,
                  color: hoveredCard === "institutes" ? "#1d4ed8" : "#2f80ed",
                  transition: "all 0.3s ease",
                }}
                onClick={() => navigate("/institutes/all?tab=thalir")}
              >
                View details →
              </Typography>
            </CardContent>
          </Card>
        </Col>

        <Col md={4} sm={6} xs={12}>
          <Card
            className={css.serviceCountCard}
            style={getCardStyle("thalirStudents", 15)}
            onMouseEnter={() => setHoveredCard("thalirStudents")}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <PeopleIcon
                  style={{
                    color:
                      hoveredCard === "thalirStudents" ? "#1e40af" : "#2f80ed",
                    transition: "all 0.3s ease",
                  }}
                />
                <Typography
                  variant="subtitle2"
                  style={getFontStyle("thalirStudents", "title")}
                >
                  Students
                </Typography>
              </div>
              <Typography
                variant="h4"
                style={{
                  margin: "10px 0",
                  ...getFontStyle("thalirStudents", "count"),
                }}
              >
                {thalirstudentCount}
              </Typography>
              {renderGrowth(thalirStudentGrowth)}
              {sessionStorage.getItem("userType") !== "regionem" && (

                <Typography
                  variant="body2"
                  color="primary"
                  style={{
                    marginTop: "5px",
                    cursor: "pointer",
                    fontWeight: hoveredCard === "students" ? 600 : 500,
                    color: hoveredCard === "students" ? "#1d4ed8" : "#2f80ed",
                    transition: "all 0.3s ease",
                  }}
                  onClick={() => navigate("/admin/users/all?tab=thalir")}
                >
                  View details →
                </Typography>
              )}
            </CardContent>
          </Card>
        </Col>

        <Col md={4} sm={6} xs={12}>
          <Card
            className={css.serviceCountCard}
            style={getCardStyle("thalirTerms", 16)}
            onMouseEnter={() => setHoveredCard("thalirTerms")}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <GavelIcon
                  style={{
                    color:
                      hoveredCard === "thalirTerms" ? "#1e40af" : "#2f80ed",
                    transition: "all 0.3s ease",
                  }}
                />
                <Typography
                  variant="subtitle2"
                  style={getFontStyle("thalirTerms", "title")}
                >
                  MoU Approved
                </Typography>
              </div>
              <Typography
                variant="h4"
                style={{
                  margin: "10px 0",
                  ...getFontStyle("thalirTerms", "count"),
                }}
              >
                {termsthalirCount}
              </Typography>
              {renderGrowth(thalirTermsGrowth)}
              <Typography
                variant="body2"
                color="primary"
                style={{
                  marginTop: "5px",
                  cursor: "pointer",
                  fontWeight: hoveredCard === "terms" ? 600 : 500,
                  color: hoveredCard === "terms" ? "#1d4ed8" : "#2f80ed",
                  transition: "all 0.3s ease",
                }}
                // onClick={handleInstitutesClick}
                onClick={() =>
                  navigate("/institutes/all?tab=thalir&&termsAccepted=true")
                }
              >
                View details →
              </Typography>
            </CardContent>
          </Card>
        </Col>
      </Row>

      {/* Management Section */}
      <h5
        style={{
          fontWeight: 600,
          marginTop: 25,
          marginBottom: 15,
          color: "#2f80ed",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <NavigationIcon style={{ fontSize: 20 }} />
        Quick Navigation
      </h5>
      <Row>
        <Col md={6} sm={12} className="mb-3">
          <Card
            className={css.serviceCountCard}
            style={{ padding: "15px", textAlign: "left" }}
          >
            <CardContent>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  marginBottom: 8,
                }}
              >
                <SchoolIcon color="primary" />
                <Typography variant="subtitle1" fontWeight={600}>
                  Manage Schools
                </Typography>
              </div>
              <Typography
                variant="body2"
                color="text.secondary"
                style={{ marginBottom: "12px" }}
              >
                School master data management
              </Typography>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "auto",
                  gap: "8px",
                }}
              >
                <button
                  style={{
                    padding: "8px 20px",
                    borderRadius: "6px",
                    border: "1px solid #f39c12",
                    backgroundColor: "transparent",
                    color: "#f39c12",
                    fontWeight: "500",
                    cursor: "pointer",
                    fontSize: "14px",
                    transition: "all 0.2s ease",
                    minWidth: "70px",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#f39c12";
                    e.target.style.color = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#f39c12";
                  }}
                  // onClick={handleEMClick}
                  onClick={() => navigate("/institutes/all?tab=thalir")}
                >
                  Open
                </button>
                {sessionStorage.getItem("userType") !== "regionem" && (
                  <button
                    style={{
                      padding: "8px 20px",
                      borderRadius: "6px",
                      border: "1px solid #27ae60",
                      backgroundColor: "transparent",
                      color: "#27ae60",
                      fontWeight: "500",
                      cursor: "pointer",
                      fontSize: "14px",
                      transition: "all 0.2s ease",
                      minWidth: "90px",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#27ae60";
                      e.target.style.color = "white";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "transparent";
                      e.target.style.color = "#27ae60";
                    }}
                    onClick={() => navigate("/institutes/insert?tab=thalir")}
                  >
                    + Add New
                  </button>
                )}
              </div>
            </CardContent>
          </Card>
        </Col>
        {sessionStorage.getItem("userType") !== "regionem" && (

          <Col md={6} sm={12} className="mb-3">
            <Card
              className={css.serviceCountCard}
              style={{ padding: "15px", textAlign: "left" }}
            >
              <CardContent>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    marginBottom: 8,
                  }}
                >
                  <PeopleIcon color="primary" />
                  <Typography variant="subtitle1" fontWeight={600}>
                    Manage Students
                  </Typography>
                </div>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  style={{ marginBottom: "12px" }}
                >
                  Thalir student management and filtering
                </Typography>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "auto",
                    gap: "8px",
                  }}
                >
                  <button
                    style={{
                      padding: "8px 20px",
                      borderRadius: "6px",
                      border: "1px solid #f39c12",
                      backgroundColor: "transparent",
                      color: "#f39c12",
                      fontWeight: "500",
                      cursor: "pointer",
                      fontSize: "14px",
                      transition: "all 0.2s ease",
                      minWidth: "70px",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#f39c12";
                      e.target.style.color = "white";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "transparent";
                      e.target.style.color = "#f39c12";
                    }}
                    // onClick={handleEMClick}
                    onClick={() => navigate("/admin/users/all?tab=thalir")}
                  >
                    Open
                  </button>
                  {sessionStorage.getItem("userType") !== "regionem" && (
                    <button
                      style={{
                        padding: "8px 20px",
                        borderRadius: "6px",
                        border: "1px solid #27ae60",
                        backgroundColor: "transparent",
                        color: "#27ae60",
                        fontWeight: "500",
                        cursor: "pointer",
                        fontSize: "14px",
                        transition: "all 0.2s ease",
                        minWidth: "90px",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#27ae60";
                        e.target.style.color = "white";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "transparent";
                        e.target.style.color = "#27ae60";
                      }}
                      onClick={() => navigate("/user/register/no_id?tab=thalir")}
                    >
                      + Add New
                    </button>
                  )}
                </div>
              </CardContent>
            </Card>
          </Col>
        )}
      </Row>

      {/* Cluster MOU - Schools that uploaded Excel sheets (Admin only) */}
      {hasAdmin && thalirUploadedSheets.length > 0 && (
        <div style={{ marginTop: 24 }}>
          <h5
            style={{
              fontWeight: 600,
              marginBottom: 15,
              color: "#2f80ed",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <SchoolIcon style={{ fontSize: 20 }} />
            Cluster MOU - Schools with Uploaded Excel Sheets
          </h5>
          <Card style={{ padding: 16, borderRadius: 12 }}>
            <CardContent style={{ padding: 0 }}>
              <Typography variant="body2" color="text.secondary" sx={{ marginBottom: 2 }}>
                Schools (Cluster MOU) that uploaded Excel sheets with school names and student counts
              </Typography>
              <div style={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
                  <thead>
                    <tr style={{ borderBottom: "2px solid #e0e0e0" }}>
                      <th style={{ padding: "10px 12px", textAlign: "left", fontWeight: 600 }}>School Name</th>
                      <th style={{ padding: "10px 12px", textAlign: "left", fontWeight: 600 }}>Officer</th>
                      <th style={{ padding: "10px 12px", textAlign: "right", fontWeight: 600 }}>Schools in Sheet</th>
                      <th style={{ padding: "10px 12px", textAlign: "right", fontWeight: 600 }}>Students (from sheet)</th>
                      <th style={{ padding: "10px 12px", textAlign: "left", fontWeight: 600 }}>Uploaded At</th>
                    </tr>
                  </thead>
                  <tbody>
                    {thalirUploadedSheets.map((item, idx) => (
                      <tr key={idx} style={{ borderBottom: "1px solid #eee" }}>
                        <td style={{ padding: "10px 12px" }}>{item.instituteName}</td>
                        <td style={{ padding: "10px 12px" }}>{item.officerName}</td>
                        <td style={{ padding: "10px 12px", textAlign: "right" }}>{item.schoolsCount}</td>
                        <td style={{ padding: "10px 12px", textAlign: "right" }}>{item.totalStudentsFromSheet}</td>
                        <td style={{ padding: "10px 12px" }}>
                          {item.uploadedAt
                            ? new Date(item.uploadedAt).toLocaleString("en-IN", {
                              dateStyle: "short",
                              timeStyle: "short",
                            })
                            : "-"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </CardContent>
          </Card>
        </div>
      )}

      <h5
        style={{
          fontWeight: 600,
          marginTop: 25,
          marginBottom: 15,
          color: "#2f80ed",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <SchoolIcon style={{ fontSize: 20 }} />
        Thalir Chapters & MoU Details
      </h5>

      <Row>
        {resultData.map((region, index) => (
          <Col md={4} sm={12} key={index} className="mb-4">
            <Card
              style={getCardStyle(`region-${index}`, index)}
              onMouseEnter={() => setHoveredCard(`region-${index}`)}
              onMouseLeave={() => setHoveredCard(null)}
              className="shadow-sm rounded-lg border"
            >
              <CardContent>
                {/* Header - Region + Zone */}
                <div className="flex justify-between items-center mb-3">
                  <Typography
                    variant="h6"
                    style={getFontStyle(`region-${index}`, "title")}
                  >
                    Region: {region.region}
                  </Typography>
                </div>

                <div
                  style={{
                    background: "#fff7e6",
                    borderRadius: "10px",
                    padding: "10px",
                    marginBottom: "12px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div style={{ textAlign: "center", flex: 1 }}>
                    <Typography
                      variant="h5"
                      style={getFontStyle(`region-${index}`, "count")}
                    >
                      {region.chapterCount}
                    </Typography>
                    <Typography
                      variant="body2"
                      style={getFontStyle(`region-${index}`, "description")}
                    >
                      Total Chapters
                    </Typography>
                  </div>

                  <div style={{ textAlign: "center", flex: 1 }}>
                    <Typography
                      variant="h5"
                      style={getFontStyle(`region-${index}`, "count")}
                    >
                      {region.totalStudents}
                    </Typography>
                    <Typography
                      variant="body2"
                      style={getFontStyle(`region-${index}`, "description")}
                    >
                      Total Students
                    </Typography>
                  </div>
                </div>

                {/* Single & Bulk MoUs */}
                {/* Single & Bulk MoUs */}
                <div className="mt-2 space-y-2">
                  {/* Single MoUs Row */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      <span role="img" aria-label="single">
                        📄
                      </span>
                      <Typography
                        variant="body2"
                        style={getFontStyle(`region-${index}`, "description")}
                      >
                        <strong>Single MoUs:</strong> {region.single.moUs}
                      </Typography>
                    </div>
                    <Typography
                      variant="body2"
                      style={getFontStyle(`region-${index}`, "description")}
                    >
                      Students: {region.single.students}
                    </Typography>
                  </div>

                  {/* Bulk MoUs Row */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      <span role="img" aria-label="bulk">
                        👥
                      </span>
                      <Typography
                        variant="body2"
                        style={getFontStyle(`region-${index}`, "description")}
                      >
                        <strong>Bulk MoUs (Cluster):</strong> {region.bulk.moUs}
                      </Typography>
                    </div>
                    <Typography
                      variant="body2"
                      style={getFontStyle(`region-${index}`, "description")}
                    >
                      Students: {region.bulk.students}
                    </Typography>
                  </div>
                </div>

                {/* Link */}
                {/* Action buttons for details */}
                <div
                  style={{
                    marginTop: "12px",
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "12px",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      cursor: "pointer",
                      fontWeight:
                        hoveredCard === `region-single-${index}` ? 600 : 500,
                      color:
                        hoveredCard === `region-single-${index}`
                          ? "#1d4ed8"
                          : "#2f80ed",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={() =>
                      setHoveredCard(`region-single-${index}`)
                    }
                    onMouseLeave={() => setHoveredCard(null)}
                    onClick={() =>
                      navigate(
                        `/region/mou-details?regionId=${region.region}&mouType=Single`
                      )
                    }
                  >
                    View Single MoUs →
                  </Typography>

                  <Typography
                    variant="body2"
                    style={{
                      cursor: "pointer",
                      fontWeight:
                        hoveredCard === `region-bulk-${index}` ? 600 : 500,
                      color:
                        hoveredCard === `region-bulk-${index}`
                          ? "#1d4ed8"
                          : "#2f80ed",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={() => setHoveredCard(`region-bulk-${index}`)}
                    onMouseLeave={() => setHoveredCard(null)}
                    onClick={
                      () =>
                        navigate(
                          `/region/mou-details?regionId=${region.region}&mouType=Bulk`
                        )
                      // navigate(`/region/${region.region}/bulk-mou-details`)
                    }
                  >
                    View Bulk MoUs →
                  </Typography>
                </div>
              </CardContent>
            </Card>
          </Col>
        ))}
      </Row>

      {/* <Row>
        {resultData.map((region, index) => (
          <Col md={6} sm={12} key={index} className="mb-4">
            <Card
              style={getCardStyle(`region-${index}`, index)}
              onMouseEnter={() => setHoveredCard(`region-${index}`)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <CardContent>
                <Typography
                  variant="h6"
                  style={{
                    ...getFontStyle(`region-${index}`, "title"),
                    marginBottom: "10px",
                  }}
                >
                  {region.region}
                </Typography>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <Typography
                      variant="body1"
                      style={getFontStyle(`region-${index}`, "description")}
                    >
                      Total Chapters: {region.chapterCount}
                    </Typography>
                    <Typography
                      variant="body2"
                      style={getFontStyle(`region-${index}`, "description")}
                    >
                      Single MoUs: {region.single.moUs} (Students:{" "}
                      {region.single.students})
                    </Typography>
                    <Typography
                      variant="body2"
                      style={getFontStyle(`region-${index}`, "description")}
                    >
                      Bulk MoUs (Cluster): {region.bulk.moUs} (Students:{" "}
                      {region.bulk.students})
                    </Typography>
                  </div>
                  <div>
                    <Typography
                      variant="h5"
                      style={getFontStyle(`region-${index}`, "count")}
                    >
                      {region.chapterCount}
                    </Typography>
                    <Typography
                      variant="body2"
                      style={getFontStyle(`region-${index}`, "description")}
                    >
                      Total Chapters
                    </Typography>
                    <Typography
                      variant="h5"
                      style={getFontStyle(`region-${index}`, "count")}
                    >
                      {region.totalStudents}
                    </Typography>
                    <Typography
                      variant="body2"
                      style={getFontStyle(`region-${index}`, "description")}
                    >
                      Total Students
                    </Typography>
                  </div>
                </div>
                <Typography
                  variant="body2"
                  color="primary"
                  style={{
                    marginTop: "10px",
                    cursor: "pointer",
                    fontWeight: hoveredCard === `region-${index}` ? 600 : 500,
                    color:
                      hoveredCard === `region-${index}` ? "#1d4ed8" : "#2f80ed",
                    transition: "all 0.3s ease",
                  }}
                  onClick={() => navigate(`/region/${region.region}/details`)}
                >
                  View details →
                </Typography>
              </CardContent>
            </Card>
          </Col>
        ))}
      </Row> */}

      <h5
        style={{
          fontWeight: 600,
          marginTop: 25,
          marginBottom: 15,
          color: "#2f80ed",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <BuildIcon style={{ fontSize: 20 }} />
        Shared Utilities
      </h5>
      <Row>
        {sessionStorage.getItem("userType") !== "regionem" && (
          <Col md={6} sm={12} className="mb-3">
            <Card
              className={css.serviceCountCard}
              style={{ padding: "15px", textAlign: "left" }}
            >
              <CardContent>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    marginBottom: 6,
                  }}
                >
                  <MarkEmailReadIcon
                    fontSize="small"
                    style={{ color: "#2f80ed" }}
                  />
                  <Typography variant="subtitle1" fontWeight={600}>
                    Mass Email
                  </Typography>
                </div>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  style={{ marginBottom: "12px" }}
                >
                  Targeted bulk email campaigns across modules
                </Typography>

                <button
                  style={{
                    padding: "8px 20px",
                    borderRadius: "6px",
                    border: "1px solid #f39c12",
                    backgroundColor: "transparent",
                    color: "#f39c12",
                    fontWeight: "500",
                    cursor: "pointer",
                    fontSize: "14px",
                    transition: "all 0.2s ease",
                    minWidth: "70px",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#f39c12";
                    e.target.style.color = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#f39c12";
                  }}
                  onClick={handleMassEmailClick}
                >
                  Open
                </button>
              </CardContent>
            </Card>
          </Col>
        )}

        <Col md={6} sm={12} className="mb-3">
          <Card
            className={css.serviceCountCard}
            style={{ padding: "15px", textAlign: "left" }}
          >
            <CardContent>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  marginBottom: 6,
                }}
              >
                <HistoryIcon fontSize="small" style={{ color: "#2f80ed" }} />
                <Typography variant="subtitle1" fontWeight={600}>
                  Email History
                </Typography>
              </div>
              <Typography
                variant="body2"
                color="text.secondary"
                style={{ marginBottom: "12px" }}
              >
                Delivery status, recipient counts, performance analytics
              </Typography>
              {/* <button
                className={`${css.serviceBtn} outlineBtn`}
                onClick={handleEmailHistoryClick}
              >
                Open
              </button> */}
              <button
                style={{
                  padding: "8px 20px",
                  borderRadius: "6px",
                  border: "1px solid #f39c12",
                  backgroundColor: "transparent",
                  color: "#f39c12",
                  fontWeight: "500",
                  cursor: "pointer",
                  fontSize: "14px",
                  transition: "all 0.2s ease",
                  minWidth: "70px",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f39c12";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#f39c12";
                }}
                onClick={handleEmailHistoryClick}
              >
                Open
              </button>
            </CardContent>
          </Card>
        </Col>

        {/* {hasAdmin && (
          <>
            <Col md={6} sm={12} className="mb-3">
              <Card className={css.serviceCountCard} style={{ padding: "15px", textAlign: "left" }}>
                <CardContent>
                  <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
                    <AssignmentIndIcon fontSize="small" style={{ color: "#2f80ed" }} />
                    <Typography variant="subtitle1" fontWeight={600}>Audit & History</Typography>
                  </div>
                  <Typography variant="body2" color="text.secondary" style={{ marginBottom: "12px" }}>
                    MoU history, student uploads, role assignments for audit
                  </Typography>
                  <button
                    style={{ padding: "8px 20px", borderRadius: "6px", border: "1px solid #f39c12", backgroundColor: "transparent", color: "#f39c12", fontWeight: "500", cursor: "pointer", fontSize: "14px", transition: "all 0.2s ease", minWidth: "70px" }}
                    onMouseEnter={(e) => { e.target.style.backgroundColor = "#f39c12"; e.target.style.color = "white"; }}
                    onMouseLeave={(e) => { e.target.style.backgroundColor = "transparent"; e.target.style.color = "#f39c12"; }}
                    onClick={handleAuditHistoryClick}
                  >
                    Open
                  </button>
                </CardContent>
              </Card>
            </Col>

            <Col md={6} sm={12} className="mb-3">
              <Card className={css.serviceCountCard} style={{ padding: "15px", textAlign: "left" }}>
                <CardContent>
                  <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
                    <BuildIcon fontSize="small" style={{ color: "#2f80ed" }} />
                    <Typography variant="subtitle1" fontWeight={600}>Configuration</Typography>
                  </div>
                  <Typography variant="body2" color="text.secondary" style={{ marginBottom: "12px" }}>
                    Durations, reminders, email template settings
                  </Typography>
                  <button
                    style={{ padding: "8px 20px", borderRadius: "6px", border: "1px solid #f39c12", backgroundColor: "transparent", color: "#f39c12", fontWeight: "500", cursor: "pointer", fontSize: "14px", transition: "all 0.2s ease", minWidth: "70px" }}
                    onMouseEnter={(e) => { e.target.style.backgroundColor = "#f39c12"; e.target.style.color = "white"; }}
                    onMouseLeave={(e) => { e.target.style.backgroundColor = "transparent"; e.target.style.color = "#f39c12"; }}
                    onClick={handleConfigurationClick}
                  >
                    Open
                  </button>
                </CardContent>
              </Card>
            </Col>

            <Col md={6} sm={12} className="mb-3">
              <Card className={css.serviceCountCard} style={{ padding: "15px", textAlign: "left" }}>
                <CardContent>
                  <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
                    <DescriptionIcon fontSize="small" style={{ color: "#2f80ed" }} />
                    <Typography variant="subtitle1" fontWeight={600}>Historical MoU</Typography>
                  </div>
                  <Typography variant="body2" color="text.secondary" style={{ marginBottom: "12px" }}>
                    Past MoU docs, EM & Institute details, update signed PDF
                  </Typography>
                  <button
                    style={{ padding: "8px 20px", borderRadius: "6px", border: "1px solid #f39c12", backgroundColor: "transparent", color: "#f39c12", fontWeight: "500", cursor: "pointer", fontSize: "14px", transition: "all 0.2s ease", minWidth: "70px" }}
                    onMouseEnter={(e) => { e.target.style.backgroundColor = "#f39c12"; e.target.style.color = "white"; }}
                    onMouseLeave={(e) => { e.target.style.backgroundColor = "transparent"; e.target.style.color = "#f39c12"; }}
                    onClick={handleHistoricalMoUClick}
                  >
                    Open
                  </button>
                </CardContent>
              </Card>
            </Col>
          </>
        )} */}

        <Col md={6} sm={12} className="mb-3">
          <Card
            className={css.serviceCountCard}
            style={{ padding: "15px", textAlign: "left" }}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <GavelIcon
                  fontSize="small"
                  style={{ fontSize: 20, color: "#2f80ed" }}
                />
                <Typography variant="subtitle1" fontWeight={600}>
                  Manage Terms & Conditions
                </Typography>
              </div>
              <Typography
                variant="body2"
                color="text.secondary"
                style={{ marginBottom: "12px" }}
              >
                YUVA T&C templates and submissions
              </Typography>
              {/* <button
                className={`${css.serviceBtn} outlineBtn`}
                onClick={handleTermsAndConditionsClick}
              >
                Open
              </button> */}
              <button
                style={{
                  padding: "8px 20px",
                  borderRadius: "6px",
                  border: "1px solid #f39c12",
                  backgroundColor: "transparent",
                  color: "#f39c12",
                  fontWeight: "500",
                  cursor: "pointer",
                  fontSize: "14px",
                  transition: "all 0.2s ease",
                  minWidth: "70px",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f39c12";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#f39c12";
                }}
                onClick={handleTermsAndConditionsClick}
              >
                Open
              </button>
            </CardContent>
          </Card>
        </Col>

        <Col md={6} sm={12} className="mb-3">
          <Card
            className={css.serviceCountCard}
            style={{ padding: "15px", textAlign: "left" }}
          >
            <CardContent>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <EditNoteIcon
                  fontSize="small"
                  style={{ fontSize: 20, color: "#2f80ed" }}
                />
                <Typography variant="subtitle1" fontWeight={600}>
                  Manage Content
                </Typography>
              </div>
              <Typography
                variant="body2"
                color="text.secondary"
                style={{ marginBottom: "12px" }}
              >
                Create and update static pages
              </Typography>
              {/* <button
                className={`${css.serviceBtn} outlineBtn`}
                onClick={handleContentClick}
              >
                Open
              </button> */}
              <button
                style={{
                  padding: "8px 20px",
                  borderRadius: "6px",
                  border: "1px solid #f39c12",
                  backgroundColor: "transparent",
                  color: "#f39c12",
                  fontWeight: "500",
                  cursor: "pointer",
                  fontSize: "14px",
                  transition: "all 0.2s ease",
                  minWidth: "70px",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f39c12";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#f39c12";
                }}
                onClick={handleContentClick}
              >
                Open
              </button>
            </CardContent>
          </Card>
        </Col>
      </Row>
    </div>
  );


  const ITEMS_PER_PAGE = 10;

  const renderMouDashboard = () => {

    return (
      <div>
        <h5
          style={{
            fontWeight: 600,
            marginTop: 10,
            marginBottom: 15,
            color: "#2f80ed",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <DescriptionIcon style={{ fontSize: 20 }} />
          MoU Dashboard
        </h5>

        {/* Filters Card */}
        <Card
          style={{
            padding: "20px",
            marginBottom: "20px",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              marginBottom: "15px",
            }}
          >
            <FilterListIcon style={{ fontSize: 20, color: "#2f80ed" }} />
            <Typography variant="subtitle1" fontWeight={600}>
              Filters
            </Typography>
          </div>

          <Row>
            <Col md={4} sm={6} xs={12} style={{ marginBottom: "15px" }}>
              <FormControl fullWidth size="small">
                <InputLabel>Module</InputLabel>
                <Select
                  value={mouFilters.module}
                  label="Module"
                  onChange={(e) =>
                    setMouFilters({ ...mouFilters, module: e.target.value })
                  }
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value="YUVA">YUVA</MenuItem>
                  <MenuItem value="THALIR">THALIR</MenuItem>
                </Select>
              </FormControl>
            </Col>
            {/* Uncomment / implement when ready
          <Col md={4} sm={6} xs={12} style={{ marginBottom: "15px" }}>
            <FormControl fullWidth size="small">
              <InputLabel>Chapter</InputLabel>
              <Select ... />
            </FormControl>
          </Col>
          <Col md={4} sm={6} xs={12} style={{ marginBottom: "15px" }}>
            <FormControl fullWidth size="small">
              <InputLabel>Institute</InputLabel>
              <Select ... />
            </FormControl>
          </Col> */}
          </Row>
        </Card>

        {/* Status Chips */}
        <div
          style={{
            display: "flex",
            gap: "10px",
            marginBottom: "20px",
            flexWrap: "wrap",
          }}
        >
          <Chip
            label={`Active (${mouDashboardData.active?.count || 0})`}
            onClick={() => setMouActiveTab("active")}
            color={mouActiveTab === "active" ? "primary" : "default"}
            style={{ cursor: "pointer" }}
          />
          <Chip
            label={`Expiring (${mouDashboardData.expiring?.count || 0})`}
            onClick={() => setMouActiveTab("expiring")}
            color={mouActiveTab === "expiring" ? "warning" : "default"}
            style={{ cursor: "pointer" }}
          />
          <Chip
            label={`Expired (${mouDashboardData.expired?.count || 0})`}
            onClick={() => setMouActiveTab("expired")}
            color={mouActiveTab === "expired" ? "error" : "default"}
            style={{ cursor: "pointer" }}
          />
        </div>

        {mouLoading ? (
          <div style={{ textAlign: "center", padding: "40px" }}>
            <CircularProgress />
          </div>
        ) : (
          <>
            {/* Search Input */}
            <div style={{ marginBottom: 16, maxWidth: 400 }}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                placeholder="Search institute, chapter or module..."
                value={mouSearchTerm}
                onChange={(e) => setMouSearchTerm(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </div>

            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell><strong>Institute Name</strong></TableCell>
                    <TableCell><strong>Chapter</strong></TableCell>
                    <TableCell><strong>Module</strong></TableCell>
                    <TableCell><strong>Expiry Date</strong></TableCell>
                    <TableCell><strong>Days Until Expiry</strong></TableCell>
                    <TableCell><strong>Status</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {totalFiltered === 0 ? (
                    <TableRow>
                      <TableCell colSpan={6} align="center" style={{ padding: "40px" }}>
                        No MoUs found
                      </TableCell>
                    </TableRow>
                  ) : (
                    paginatedItems.map((mou, index) => {
                      const expiryDate = mou.calculatedExpiryDate
                        ? new Date(mou.calculatedExpiryDate).toLocaleString("en-GB", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        })
                        : "N/A";

                      const daysUntil = mou.daysUntilExpiry ?? "N/A";
                      const statusColor =
                        mou.status === "active" ? "success" :
                          mou.status === "expiring" ? "warning" : "error";

                      return (
                        <TableRow key={mou._id || index} hover>
                          <TableCell>{mou.name || "N/A"}</TableCell>
                          <TableCell>{mou.chapterName || "N/A"}</TableCell>
                          <TableCell>{mou.isThalir ? "THALIR" : "YUVA"}</TableCell>
                          <TableCell>{expiryDate}</TableCell>
                          <TableCell>
                            {typeof daysUntil === "number" ? `${daysUntil} days` : daysUntil}
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={(mou.status || "UNKNOWN").toUpperCase()}
                              color={statusColor}
                              size="small"
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })
                  )}
                </TableBody>
              </Table>

              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                component="div"
                count={totalFiltered}
                rowsPerPage={mouRowsPerPage}
                page={mouPage}
                onPageChange={(_, newPage) => setMouPage(newPage)}
                onRowsPerPageChange={(event) => {
                  setMouRowsPerPage(parseInt(event.target.value, 10));
                  setMouPage(0);
                }}
                labelRowsPerPage="Rows per page:"
                labelDisplayedRows={({ from, to, count }) =>
                  `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`
                }
                sx={{
                  borderTop: "1px solid",

                  // 👇 Force ALL pagination text black
                  "& .MuiTablePagination-toolbar": {
                    color: "#000",
                  },
                  "& .MuiTablePagination-displayedRows": {
                    color: "#000 !important",
                    fontWeight: 600,
                  },

                  // "& .MuiTablePagination-displayedRows": {
                  //   color: "#000",
                  //   // fontWeight: 500,
                  // },

                  "& .MuiTablePagination-selectLabel": {
                    color: "#000",
                  },

                  "& .MuiTablePagination-select": {
                    color: "#000",
                  },

                  "& .MuiSvgIcon-root": {
                    color: "#000",
                  },
                }}
              />
            </TableContainer>
          </>
        )}
      </div>
    );
  };

  return isLoading ? (
    <Loader />
  ) : (
    <div className={css.outerDiv}>
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            backgroundColor: "#f9fbfd",
            borderRadius: 8,
          }}
        >
          <Tabs
            value={activeTab}
            onChange={(e, v) => setActiveTab(v)}
            textColor="primary"
            TabIndicatorProps={{ style: { display: "none" } }} // Hide default underline
            sx={{
              backgroundColor: "#f2f4f7",
              borderRadius: "8px",
              padding: "6px",
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 500,
                minHeight: 40,
                borderRadius: "8px",
                marginX: "8px",
                padding: "6px 16px",
                marginRight: 1,
                color: "#4f4f4f",
                "& .MuiSvgIcon-root": {
                  color: "#4f4f4f",
                },
              },
              "& .Mui-selected": {
                backgroundColor: "#2f80ed",
                color: "#fff",
                "& .MuiSvgIcon-root": {
                  color: "#fff",
                },
              },
            }}
          >
            <Tab
              value="common"
              icon={<DataUsageIcon fontSize="small" />}
              label="Central Data"
              iconPosition="start"
            />
            {hasAdmin && (
              <Tab
                value="mou-dashboard"
                icon={<DescriptionIcon fontSize="small" />}
                label="MoU Dashboard"
                iconPosition="start"
              />
            )}
            {/* Conditionally show Yuva tab */}
            {(userType === "admin" ||
              (userType === "regionem" && regionEMfor === "YUVA")) && (
                <Tab
                  value="yuva"
                  icon={<AccountBalanceIcon fontSize="small" />}
                  label="YUVA"
                  iconPosition="start"
                />
              )}

            {/* Conditionally show Thalir tab */}
            {(userType === "admin" ||
              (userType === "regionem" && regionEMfor === "THALIR")) && (
                <Tab
                  value="thalir"
                  icon={<SchoolIcon fontSize="small" />}
                  label="Thalir"
                  iconPosition="start"
                />
              )}
          </Tabs>
        </div>

        {/* Conditional Rendering for Tabs */}
        {activeTab === "common" && renderCommonOverview()}
        {activeTab === "yuva" && renderYuvaOverview()}
        {activeTab === "thalir" && renderThalirOverview()}
        {activeTab === "mou-dashboard" && renderMouDashboard()}

        {/* Chapter details dialog for Region EM */}
        <Dialog
          open={chapterDetailsOpen}
          onClose={() => setChapterDetailsOpen(false)}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle>
            Institutes & Schools - {selectedChapterName}
          </DialogTitle>
          <DialogContent dividers>
            {chapterDetailsLoading ? (
              <div style={{ textAlign: "center", padding: "24px" }}>
                <CircularProgress />
              </div>
            ) : chapterDetails.length === 0 ? (
              <Typography variant="body2" color="text.secondary">
                No institutes or schools found for this chapter.
              </Typography>
            ) : (
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <strong>Name</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Type</strong>
                      </TableCell>
                      <TableCell align="right">
                        <strong>Total Students</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {chapterDetails.map((inst) => (
                      <TableRow key={inst._id}>
                        <TableCell>{inst.name}</TableCell>
                        <TableCell>{inst.isThalir ? "Thalir School" : "YUVA College"}</TableCell>
                        <TableCell align="right">
                          {inst.studentCount ?? 0}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
};

export default HomePage;
